import ikea from 'ikea-jssdk';

// ABTest可以参考：https://confluence.build.ingka.ikea.com/pages/viewpage.action?pageId=481952880
export function abTestGetVariation(params) {
  return ikea.abtest.getVariation({
    experimentId: params.experimentId,
    // 如果数据获取失败的默认数据
    defaultVariation: params.defaultVariation,
  });
}

// abTest
export const getAbTestResult = async (experimentId, defaultVariation, storageKey) => {
  let value;
  await abTestGetVariation({
    experimentId, // 实验id
    defaultVariation, // 如果数据获取失败的默认数据
  })
    .then((layout) => {
      value = layout.value;
    })
    .catch(() => {
      value = 'hide';
    })
    .finally(() => {
      window.localStorage.setItem(storageKey, value);
      window.gio('visitor.set', `abtest_${experimentId}`, value);
    });
};
